<!-- Menu header -->
<div class="navbar-header" style="background: #0065d7 !important;">
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto">
            <!-- App Branding -->
            <a class="navbar-brand" [routerLink]="['/']">
                <span>
                    <img src="assets/images/logo/logowhite.png" alt="brand-logo" style="margin-top: -20px !important;
                               width: auto !important; height: 55px !important;" />
                </span>
                <h1 style="color: #fff; font-weight: bold !important;">PROMOSCP</h1>
            </a>
        </li>

        <!-- Menu Toggler -->
        <li class="nav-item nav-toggle" style="margin-top: -78px; margin-left: 190px;">
            <a class="nav-link modern-nav-toggle d-none d-xl-block pr-0" (click)="toggleSidebarCollapsible()">
                <i [ngClass]="isCollapsed === true ? 'icon-circle' : 'icon-disc'"
                    class="toggle-icon feather font-medium-4 collapse-toggle-icon" style="color: #fff !important;">
                </i>
            </a>
            <a class="nav-link modern-nav-toggle d-block d-xl-none pr-0" (click)="toggleSidebar()"
                style="color: #fff !important; cursor: pointer;">
                <i data-feather="x" class="font-medium-4 toggle-icon" style="color: #fff !important;"></i>
            </a>
        </li>
    </ul>
</div>
<!--/ Menu header -->

<!-- Main menu -->
<div class="main-menu-content" [perfectScrollbar] (scroll)="onSidebarScroll()">
    <ul class="navigation navigation-main pt-1" layout="vertical" core-menu></ul>
</div>
<!--/ Main menu -->